import styled from "@emotion/styled";

export const BackToTopButtonContainer = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
`;
